import { batteryMonitoringApiScopes, loginRequest, msalInstance } from '@/app/msal';

export const getMicrosoftGraphAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: activeAccount,
  });

  return response.accessToken;
};

export const getApiAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  const response = await msalInstance.acquireTokenSilent({
    scopes: batteryMonitoringApiScopes,
    account: activeAccount,
  });

  return response.accessToken;
};
